<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('token.detail.title-label') }}</h3>
        </div>

        <div v-if="(! isLoaded)">
            <p class="card-text m-0 p-0 mt-2 pb-4">
                {{ $t('loading') }}
            </p>
        </div>

        <div class="container center-items">
            <div v-if="(isLoaded)">
                <!-- 所有している HEC 量 / 受領 & 送付ボタンの表示領域 -->
                <div class="container center-items m-0 p-0">
                    <div class="card card-pricing text-center p-0 m-0 mt-4 overflow-hidden">
                        <div class="bg-success token-detail">
                            <span class="h6 font-weight-normal w-60 mx-auto px-4 rounded-bottom bg-white shadow-sm text-success">
                                {{ $t('token.detail.sub-title-label') }}
                            </span>
                        </div>

                        <div class="card-body p-0 m-0 mt-4 mb-4 d-flex flex-column">
                            <!-- 所有している HEC 量 -->
                            <div class="d-flex flex-row justify-content-center mt-3 mb-2">
                                <span class="h4 font-weight-normal text-black text-center d-block m-0 mt-0">
                                    {{ detail.balances.hec | floor }} {{ `HEC` }}
                                </span>
                            </div>

                            <!-- 受領 & 送付ボタン -->
                            <div class="d-flex flex-row justify-content-center mt-4">
                                <button type="button" v-on:click="depositButtonHandler()" class="btn btn-success rounded-pill font-weight-bold detail-btn mr-4">
                                    {{ $t('token.detail.deposit') }}&nbsp;
                                    <img src="./images/icon-deposit.png" alt="Deposit" height="24" width="24" />
                                </button>
                                <button type="button" v-on:click="transferButtonHandler()" class="btn btn-success rounded-pill font-weight-bold detail-btn ml-4">
                                    {{ $t('token.detail.transfer') }}&nbsp;
                                    <img src="./images/icon-withdrawal.png" alt="Transfer" height="24" width="24" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="(isLoaded)" class="container center-items m-0 p-0 mt-5">
                <div v-for="tx in transactions" v-bind:key="tx.id">
                    <TokenTransactionItem
                        :tx="tx"
                        :self="self"
                        @onClickCancelButton="cancelTransferButtonHandler"
                    />
                </div>
            </div>

            <div v-if="(isLoaded)" class="container center-items text-center m-0 p-0 mt-5">
                <router-link :to="{ name: 'token-history' }" class="btn btn-primary token-history-button-label">
                    {{ $t('token.detail.history-button-label') }}
                </router-link>
            </div>
        </div>

        <!-- 出金キャンセルモーダル -->
        <vodal :show="showCancelTransferModal" :width="modalWidth" :height="450" :closeButton="false" animation="slideDown" @hide="dismissButtonHandler()">
            <div class="d-flex flex-column p-3 justify-content-end height100">
                <div class="d-flex flex-column">
                    <!-- タイトル -->
                    <div class="d-flex flex-row">
                        <h4 class="text-left text-primary width100">
                            {{ $t('token.cancel.title-label') }}
                        </h4>
                    </div>

                    <div class="d-flex flex-column mt-3">
                        <!-- 説明 -->
                        <p class="m-0 p-0">
                            {{ $t('token.cancel.description-label') }}
                        </p>

                        <!-- 送付情報 -->
                        <ul class="m-0 p-0">
                            <!-- 申請日付 -->
                            <li class="font-weight-bold mt-3">
                                {{ $t('token.cancel.date-label') }}
                            </li>
                            <li><ul><li>
                                {{ cancelContext.created_at | moment('YYYY/MM/DD HH:mm:ss') }}
                            </li>
                            </ul></li>

                            <!-- 数量 -->
                            <li class="font-weight-bold mt-2">
                                {{ $t('token.cancel.volume-label') }}
                            </li>
                            <li><ul><li>
                                {{ cancelContext.amount | round }}
                            </li></ul></li>

                            <!-- 送付先アドレス -->
                            <li class="font-weight-bold mt-2">
                                {{ $t('token.cancel.transfer-to-label') }}
                            </li>
                            <li><ul><li class="text-break">
                                {{ cancelContext.to_address }}
                            </li></ul></li>
                        </ul>

                        <!-- エラー表示 -->
                        <p class="m-0 p-0 mt-2 text-danger" v-if="(errors.id)">
                            {{ $t(`errors.${ errors.id }`) }}
                        </p>
                    </div>
                </div>

                <!-- コントロールボタン -->
                <div class="d-flex flex-row mt-auto">
                    <!-- 閉じる & キャンセルボタン -->
                    <div class="d-flex flex-row justify-content-between width100">
                        <div class="d-flex flex-row mr-auto"></div>
                        <div class="d-flex flex-row">
                            <button type="button" class="btn btn-outline-primary radius-btn modal-dismiss-btn" @click="dismissButtonHandler()">
                                {{ $t('token.cancel.close-label') }}
                            </button>
                            <button type="button" class="btn btn-primary radius-btn modal-cancel-btn ml-2" @click="processCancelTransferButtonHandler(cancelContext.id)">
                                {{ $t('token.cancel.cancel-label') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </vodal>

        <!-- 預入モーダル -->
        <vodal :show="showDepositModal" :width="modalWidth" :height="450" :closeButton="false" animation="slideDown" @hide="dismissButtonHandler()">
            <div class="d-flex flex-column p-3 justify-content-end height100">
                <!-- タイトル -->
                <div class="d-flex flex-row">
                    <h4 class="text-left text-primary width100">
                        {{ $t('token.deposit.title-label') }}
                    </h4>
                </div>

                <!-- QR コード -->
                <div class="d-flex flex-row justify-content-center align-items-center mt-4">
                    <qriously v-bind:value="self" :size="150" />
                </div>

                <!-- ウォレットアドレス -->
                <div class="d-flex flex-column form-group mt-3">
                    <label>
                        {{ $t('token.deposit.address-label') }}
                    </label>

                    <div class="input-group">
                        <input type="text" id="address" class="form-control" v-bind:value="self" disabled />
                        <div class="input-group-append">
                            <button type="button" class="btn btn-outline-primary rounded-right modal-copy-btn" @click="copyButtonHandler()">
                                {{ $t('token.deposit.copy-label') }}
                            </button>
                        </div>
                    </div>
                </div>

                <!-- 閉じる -->
                <div class="d-flex flex-row mt-auto justify-content-center">
                    <button type="button" class="btn btn-outline-primary radius-btn modal-btn" @click="dismissButtonHandler()">
                        {{ $t('token.deposit.close-label') }}
                    </button>
                </div>
            </div>
        </vodal>

        <!-- 送付モーダル -->
        <vodal :show="showTransferModal" :customStyles="{height: 'max-content'}" :width="modalWidth" :closeButton="false" animation="slideDown" :closeOnClickMask="false" @hide="dismissButtonHandler()">
            <div class="d-flex flex-column p-3 justify-content-end h-max-content">
                <div class="d-flex flex-column">
                    <!-- タイトル -->
                    <div class="d-flex flex-row">
                        <h4
                            v-if="(! (isAuthenticationView()))"
                            v-html="$t('token.transfer.title-label')"
                            class="text-left text-primary width100"
                        />
                        <h4
                            v-if="(isAuthenticationView())"
                            v-html="$t('token.transfer.authentication-title-label')"
                            class="text-left text-primary width100"
                        />
                    </div>

                    <form class="m-0 p-0" ref="transferForm" @submit.prevent="() => {}">
                        <!-- フィールド: ウォレットアドレス -->
                        <div v-if="(! isAuthenticationView())" class="d-flex flex-column mt-3">
                            <label>
                                {{ $t('token.transfer.address-label') }}
                            </label>

                            <!-- 入力画面向け -->
                            <input v-if="(isInputView())" type="text" class="form-control" v-model="inputValues.to_address"
                                placeholder="0x0000000000000000000000000000000000000000"
                                required pattern="^0[xX][0-9a-fA-F]{40}$"
                            />
                            <p v-if="(isInputView())" class="m-0 p-0 mt-3 p-2 border rounded border-danger font-weight-bold text-danger">
                                {{ $t('token.transfer.address-description') }}
                            </p>

                            <!-- 確認画面向け -->
                            <span v-if="(isConfirmView())" class="confirm-input-text font-weight-bold text-break">
                                {{ `${ inputValues.to_address }` }}
                            </span>
                            <p class="m-0 p-0 mt-2 text-danger" v-if="((errors.to_address) && (isConfirmView()))">
                                {{ $t(`errors.${ errors.to_address }`) }}
                            </p>
                        </div>

                        <!-- フィールド: 送付量 -->
                        <div v-if="(! isAuthenticationView())" class="d-flex flex-column mt-4">
                            <label>
                                {{ $t('token.transfer.amount-label') }}
                            </label>

                            <!-- 入力画面向け -->
                            <div v-if="(isInputView())" class="input-group">
                                <input type="text" class="form-control" v-model="inputValues.amount"
                                    placeholder="1.00000000"
                                    required pattern="^(?:[0-9]{1,}|[0-9]{1,}\.[0-9]{1,8})$"
                                />
                                <div class="input-group-append">
                                    <div class="input-group-text font-weight-bold">
                                        {{ `&nbsp; HEC &nbsp;` }}
                                    </div>
                                </div>
                            </div>
                            <p v-if="(isInputView())" class="m-0 p-0 mt-2"
                                v-html="$t('token.transfer.amount-description', {
                                    minimum_hec: 0.0001,
                                })"
                            ></p>

                            <!-- 確認画面向け -->
                            <span v-if="(isConfirmView())" class="confirm-input-text font-weight-bold">
                                {{ `${ inputValues.amount } HEC` }}
                            </span>
                            <p class="m-0 p-0 mt-2 text-danger" v-if="((errors.amount) && (isConfirmView()))">
                                {{ $t(`errors.${ errors.amount }`) }}
                            </p>
                        </div>
                        <!-- フィールド: 送付量 -->
                        <div v-if="(! isAuthenticationView())" class="d-flex flex-column my-4">
                            <div  v-if="(isInputView())" class="d-flex flex-row mr-auto">
                                <!-- Add checkbox here -->
                                <div class="form-check">
                                    <input class="form-check-input"
                                        type="checkbox"
                                        id="requireConfirmationEmail"
                                        v-model="sendVerifyCode"
                                        :disabled="isConfirmView()"
                                        @change="sendVerifyCode = $event.target.checked"
                                    >
                                    <label class="form-check-label" for="requireConfirmationEmail">
                                         {{ $t(`token.detail.label-check-box`) }}
                                    </label>
                                </div>
                            </div>

                            <label v-if="(isConfirmView())" class="form-check-label" for="requireConfirmationEmail">
                                {{ $t(`token.transfer.verify-code-label`) }}
                            </label>

                            <span v-if="(isConfirmView())" class="confirm-input-text font-weight-bold">
                                {{ sendVerifyCode ?
                                    $t('token.transfer.enable-verify-code') :
                                    $t('token.transfer.disable-verify-code')
                                }}
                            </span>
                            <p v-if="(isConfirmView())" class="p-0 m-3 mb-4 p-2 border rounded border-danger font-weight-bold text-danger">
                                {{ $t('token.transfer.address-description') }}
                            </p>
                        </div>
                    </form>

                    <!-- 二段階認証画面向け -->
                    <div v-if="(isAuthenticationView())" class="d-flex flex-column align-items-center mt-5">
                        <form class="form-inline" ref="authenticationForm">
                            <input type="number" class="authentication-number text-center border border-primary rounded" v-model="verifyCodes[0]" min="0" max="9" required ref="firstDigit"/>
                            <input type="number" class="authentication-number text-center border border-primary rounded" v-model="verifyCodes[1]" min="0" max="9" required ref="secondDigit"/>
                            <input type="number" class="authentication-number text-center border border-primary rounded" v-model="verifyCodes[2]" min="0" max="9" required ref="thirdDigit"/>
                            <input type="number" class="authentication-number text-center border border-primary rounded" v-model="verifyCodes[3]" min="0" max="9" required ref="fourthDigit"/>
                            <input type="number" class="authentication-number text-center border border-primary rounded" v-model="verifyCodes[4]" min="0" max="9" required ref="fifthDigit"/>
                            <input type="number" class="authentication-number text-center border border-primary rounded" v-model="verifyCodes[5]" min="0" max="9" required ref="sixthDigit"/>
                        </form>

                        <p class="d-flex flex-row m-0 p-0 mt-4 text-left" v-html="$t(
                            'token.transfer.authentication-description'
                        )"></p>
                        <p class="mt-4">
                            <button @click="resendVerifyCodeLinkHandler" class="link-style-btn">
                                {{ $t('token.transfer.resend-mail')}}
                            </button>
                        </p>
                        <p v-bind:class="{ 'invisible': !errors.verify }" class="m-0 p-0 mt-2 text-danger">
                            {{ $t(`errors.${ errors.verify }`) }}
                        </p>

                    </div>
                </div>

                <!-- コントロールボタン -->
                <div class="d-flex flex-row mt-auto">
                    <!-- 入力画面向け; 閉じる & 確認ボタン -->
                    <div v-if="(isInputView())" class="d-flex flex-row justify-content-between width100">
                        <div class="d-flex flex-row mr-auto"></div>
                        <div class="d-flex flex-row">
                            <button type="button" class="btn btn-outline-primary radius-btn modal-dismiss-btn" @click="dismissButtonHandler()">
                                {{ $t('token.transfer.close-label') }}
                            </button>
                            <button type="button" class="btn btn-primary radius-btn modal-btn ml-2" @click="transferConfirmButtonHandler()">
                                {{ $t('token.transfer.confirm-label') }}
                            </button>
                        </div>
                    </div>

                    <!-- 確認画面向け; 閉じる & 修正 & 送信ボタン -->
                    <div v-if="(isConfirmView())" class="d-flex flex-row justify-content-between width100">
                        <div class="d-flex flex-row mr-auto">
                            <button type="button" class="btn btn-outline-primary radius-btn modal-btn" @click="transferBackToInputButtonHandler()">
                                {{ $t('token.transfer.confirm-back-to-input-label') }}
                            </button>
                        </div>
                        <div class="d-flex flex-row">
                            <button type="button" class="btn btn-outline-primary radius-btn modal-dismiss-btn" @click="dismissButtonHandler()">
                                {{ $t('token.transfer.close-label') }}
                            </button>
                            <button type="button" class="btn btn-primary radius-btn modal-btn ml-2" @click="transferSubmitButtonHandler()">
                                {{ $t('token.transfer.submit-label') }}
                            </button>
                        </div>
                    </div>

                    <!-- 二段階認証画面向け; 戻る & キャンセル & 確認ボタン -->
                    <div v-if="(isAuthenticationView())" class="d-flex flex-row justify-content-between width100">
                        <div class="d-flex flex-row ml-auto">
                            <button type="button" class="btn btn-outline-primary radius-btn modal-btn" @click="processCancelTransferButtonHandler(authenticationTxTarget.id)">
                                {{ $t('token.transfer.cancel-label') }}
                            </button>
                            <button type="button" class="btn btn-primary radius-btn modal-btn ml-2" @click="transferVerifyButtonHandler()" ref="verifyButton">
                                {{ $t('token.transfer.submit-verify') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </vodal>
    </div>
</template>

<script>
    import tokenService from './../../services/TokenService';
    import userService from './../../services/UserService';
    import VueQriously from 'vue-qriously';
    import TokenTransactionItem from './../../components/TokenTransactionItem/TokenTransactionItem';
    import TextUtil from './../../utils/TextUtil';

    export default {
        name: 'TokenBalance',

        components: {
            VueQriously,
            TokenTransactionItem,
        },

        data() {
            return {
                self: '',
                detail: undefined,
                transactions: [],
                modalWidth: -1,
                showDepositModal: false,
                showTransferModal: false,
                showCancelTransferModal: false,
                errors: undefined,
                isLoaded: false,
                showConfirmTransferView: false,
                showAuthenticationTransferView: false,
                inputValues: {
                    amount    : '',
                    to_address: '',
                },
                verifyCodes: [],
                sendVerifyCode: true,
                authenticationTxTarget: {
                    id: '',
                    verifyCode: ''
                },
                cancelContext: {},
            }
        },

        created() {
            this.init();

            if (window.innerWidth > 992) {
                this.modalWidth = 500;
            }
        },

        async mounted() {
            this.fetch();
        },

        methods: {
            initErrors() {
                this.errors = {
                    id        : '',
                    amount    : '',
                    to_address: '',
                    verify    : '',
                };
            },

            init() {
                this.errors = {
                    id        : '',
                    amount    : '',
                    to_address: '',
                };
                this.inputValues = {
                    amount    : '',
                    to_address: '',
                };

                this.initAuthentication();
            },

            initAuthentication() {
                this.authenticationTxTarget = {
                    id : '',
                    verifyCode : ''
                };
            },

            isInputView() {
                return ((! this.showConfirmTransferView) && (! this.showAuthenticationTransferView));
            },

            isConfirmView() {
                return ((this.showConfirmTransferView) && (! this.showAuthenticationTransferView));
            },

            isAuthenticationView() {
                return ((! this.showConfirmTransferView) && (this.showAuthenticationTransferView));
            },

            async fetch() {
                let [ user, detail, txs ] = await Promise.all([
                    userService.getUserFrontendData(),
                    tokenService.getWallet(),
                    tokenService.getWalletLatestTransactions(),
                ]);

                if (user.data.isChild) {
                    this.$router.push('/settings');
                    return;
                }

                this.self   = (user.data.wallet) ? String(user.data.wallet.address).toLowerCase() : '';
                this.detail = detail.data;

                this.transactions = [];
                for (let i in txs.data) {
                    if (txs.data.hasOwnProperty(i) && i !== 'meta') {
                        this.transactions.push(txs.data[i]);
                    }
                }

                this.isLoaded = true;
            },

            async refresh(callback = null) {
                await this.fetch();

                if (callback) {
                    callback();
                }
            },

            depositButtonHandler() {
                this.showDepositModal = true;
            },

            transferButtonHandler() {
                this.showTransferModal = true;
                this.showConfirmTransferView  = false;
                this.showAuthenticationTransferView = false;
            },

            dismissButtonHandler(refresh = false) {
                if (refresh) {
                    this.refresh(() => {
                        this.init();

                        this.showDepositModal  = false;
                        this.showTransferModal = false;
                        this.showCancelTransferModal = false;
                    });
                } else {
                    this.init();

                    this.showDepositModal  = false;
                    this.showTransferModal = false;
                    this.showCancelTransferModal = false;
                }
                this.sendVerifyCode = true;
            },

            copyButtonHandler() {
                TextUtil.copyToClipboard(this.self);
            },

            cancelTransferButtonHandler(id) {
                this.cancelContext = this.transactions.find((item) => {
                    return (item.id === id);
                });

                if (this.cancelContext) {
                    this.showCancelTransferModal = true;
                }
            },

            async processCancelTransferButtonHandler(id) {
                try {
                    await tokenService.cancelTransaction({
                        id: id,
                    });

                    // モーダルを非表示
                    this.dismissButtonHandler(true);
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                }
            },

            transferConfirmButtonHandler() {
                // HTML5 のフォームのバリデーション機能を手動でキック
                if (this.$refs.transferForm.checkValidity()) {
                    this.showConfirmTransferView = true;
                } else {
                    this.$refs.transferForm.reportValidity();
                }
            },

            transferBackToInputButtonHandler() {
                // 確認画面 → 入力画面を表示
                this.showConfirmTransferView = false;
                this.initErrors();
            },

            async transferSubmitButtonHandler() {
                try {
                    let response;

                    if (this.sendVerifyCode) {
                        response = await tokenService.transferTransaction(this.inputValues);
                        this.authenticationTxTarget.id = response.data.id;

                        // 確認画面を非表示 → 二段階認証画面を表示
                        this.verifyCodes = [];
                        this.showConfirmTransferView = false;
                        this.showAuthenticationTransferView = true;
                    } else {
                        response = await tokenService.transferTransactionNoVerify(this.inputValues);

                        this.sendVerifyCode = true;
                        this.$router.push('/token/confirm');
                    }

                } catch (err) {
                    this.handleTransferErrors(err);
                }
            },

            handleTransferErrors(err) {
                if (err.response && err.response.data && err.response.data.errors) {
                    err.response.data.errors.forEach(errItem => {
                        if (errItem.field) {
                            this.errors[errItem.field] = errItem.message[0];
                        }
                    });
                } else {
                    console.error('Unexpected error:', err);
                }
            },

            async transferVerifyButtonHandler() {
                if (this.$refs.authenticationForm.checkValidity()) {
                    this.initErrors();
                    try {
                        // 二段階認証のリクエスト
                        this.authenticationTxTarget.verifyCode = this.verifyCodes.join('');
                        await tokenService.sendVerificationTransaction(this.authenticationTxTarget);

                        // 認証完了画面へ遷移
                        this.$router.push('/token/confirm');

                    } catch (err) {
                        if (err.response.data.errors) {
                            err.response.data.errors.forEach(errItem => {
                                this.$set(this.errors, 'verify', errItem.message[0]);
                            })
                        }
                    }
                } else {
                    this.$refs.authenticationForm.reportValidity();
                }
            },

            async resendVerifyCodeLinkHandler() {
                this.initErrors();
                try {
                    // 認証コードの再送信
                    await tokenService.requestResendVerifyCode({ 'id' : this.authenticationTxTarget.id });

                    this.verifyCodes = [];
                    alert(this.$i18n.t('token.transfer.resended-mail'));

                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            this.$set(this.errors, 'verify', errItem.message[0]);
                        })
                    }
                }
            },
        },
        watch: {
            'verifyCodes.0' : function(v) {
                if (v) {
                    if (v.length > 1) { this.$refs.firstDigit.reportValidity(); }
                    else if (v.length > 0) { this.$refs.secondDigit.focus(); }
                }
            },
            'verifyCodes.1' : function(v) {
                if (v) {
                    if (v.length > 1) { this.$refs.secondDigit.reportValidity(); }
                    else if (v.length > 0) { this.$refs.thirdDigit.focus(); }
                }
            },
            'verifyCodes.2' : function(v) {
                if (v) {
                    if (v.length > 1) { this.$refs.thirdDigit.reportValidity(); }
                    else if (v.length > 0) { this.$refs.fourthDigit.focus(); }
                }
            },
            'verifyCodes.3' : function(v) {
                if (v) {
                    if (v.length > 1) { this.$refs.fourthDigit.reportValidity(); }
                    else if (v.length > 0) { this.$refs.fifthDigit.focus(); }
                }
            },
            'verifyCodes.4' : function(v) {
                if (v) {
                    if (v.length > 1) { this.$refs.fifthDigit.reportValidity(); }
                    else if (v.length > 0) { this.$refs.sixthDigit.focus(); }
                }
            },
            'verifyCodes.5' : function(v) {
                if (v) {
                    if (v.length > 1) { this.$refs.sixthDigit.reportValidity(); }
                    else if (v.length > 0) { this.$refs.verifyButton.focus(); }
                }
            },
        },
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";
    .token-detail {
        height: 3em;
    }
    .radius-btn {
        border-radius: 0.25rem !important;
    }
    .h-max-content {
        height: max-content;
    }
    .height100 {
        height: 100%;
    }
    .width100 {
        width: 100%;
    }
    .modal-copy-btn {
        width: 80px;
    }
    .modal-cancel-btn {
        width: 155px;
    }
    .modal-btn {
        width: 100px;
    }
    .modal-dismiss-btn {
        width: 80px;
    }
    .detail-btn {
        width: 130px;
        height: 35px;
    }
    .confirm-input-text {
        font-size: 1.2em;
    }
    .btn-primary:hover,
    .btn-success:hover,
    .btn-outline-primary:hover {
        color: #fff !important;
    }
    .center-items {
        width: 100%;
        margin: 0 auto;
    }
    .token-history-button-label {
        white-space: nowrap;
    }
    .authentication-number {
        width: 50px;
        height: 50px;
        margin: 8px 8px;
        font-size: 32px;
        border-width: 2px !important;
    }
    .authentication-number::-webkit-inner-spin-button,
    .authentication-number::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
        -moz-appearance:textfield;
    }
    button.link-style-btn,
    button.link-style-btn:focus {
        cursor: pointer;
        border: none;
        outline: none;
        background: none;
        color: #6cb2eb;
        width: 240px;
    }
    button.link-style-btn:hover {
        color: #4c92bb;
    }
    @media(max-width: 460px) {
        .authentication-number {
            width: 40px;
            height: 40px;
            margin: 8px 4px;
            font-size: 28px;
            border-width: 2px !important;
        }
        .authentication-number::-webkit-inner-spin-button,
        .authentication-number::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
            -moz-appearance:textfield;
        }
    }
    @media(max-width: 428px) {
        .authentication-number {
            width: 40px;
            height: 40px;
            margin: 8px 4px;
            font-size: 1em;
            border-width: 2px !important;
        }
        .authentication-number::-webkit-inner-spin-button,
        .authentication-number::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
            -moz-appearance:textfield;
        }
    }
</style>
